import type { Content } from '../../models';

import { VisualsWithDataTypes } from '../../config/constants';

export const validateContentVersion70 = (content: Content): boolean => {
  const { type, typeSpecific } = content;

  if (typeSpecific.version < 70) {
    if (VisualsWithDataTypes.includes(type) && typeSpecific.chart) {
      if (typeSpecific.chart.dots?.firstLabel) {
        typeSpecific.chart.dots.firstLabel.line = typeSpecific.chart.dots.firstLabel.line ?? {
          enabled: true,
          stroke: '#ccc',
          strokeWidth: 1,
          strokeDasharray: 'solid',
        };
      }
    }

    // typeSpecific.version = 70;
  }

  return true;
};
